import { AppState } from '../states/app.state';
import { createSelector } from '@ngrx/store';
import { CategoriesState, TagsState } from '../states/tags.state';
import { CategoriesEnum } from '@eview/core/domain/post/post';
import { TagHelpers } from '@eview/core/domain/tags/tag.helpers';

const tagsState = (state: AppState) => state.tags;

const categoriesState = (state: AppState) => state.categories;

export const selectTags = createSelector(
  tagsState,
  (state: TagsState) => state.tags
);

export const selectCategories = createSelector(
  categoriesState,
  (state: CategoriesState) => state.categories
);